module.exports = __webpack_public_path__ + "media/images/landkit/portfolio/portfolio-cover-4-67ee5864caec102d3ccfa650130745a5.jpg";